import _ from 'lodash';

const splitMap = (delimiter, mapper) => str =>
  str.split(delimiter).filter(Boolean).map(mapper).join(delimiter);

export const normalizeName = name =>
  name ? splitMap(' ', splitMap('-', _.upperFirst))(name) : name;

export const collapseName = (str, sanitizeOptions) => (sanitizeOptions ? str : normalizeName(str));
